import { supabase } from '@/integrations/supabase/client';
import { CoachModel, CoachesState } from './types';
import { getUserGymId } from '@/utils/gymAuth';


export const updateCoach = async (
  id: string, 
  updates: Partial<CoachModel>, 
  state: CoachesState
): Promise<boolean> => {
  try {
    const gymId = getUserGymId();
    if (!gymId) {
      console.error('No gym selected');
      return false;
    }

    const { error } = await supabase.functions.invoke('coaches-management', {
      body: { 
        action: 'update_coach',
        params: { id, updates },
        gym_id: gymId
      }
    });

    if (error) throw error;

    // Update local state
    state.coaches = state.coaches.map(coach =>
      coach.id === id ? { ...coach, ...updates } : coach
    );

    return true;
  } catch (error) {
    console.error('Error in updateCoach:', error);
    return false;
  }
};

export const deleteCoach = async (id: string, state: CoachesState): Promise<boolean> => {
  try {
    const gymId = getUserGymId();
    if (!gymId) {
      console.error('No gym selected');
      return false;
    }

    const { error } = await supabase.functions.invoke('coaches-management', {
      body: { 
        action: 'delete_coach',
        params: { id },
        gym_id: gymId
      }
    });

    if (error) throw error;

    // Update local state
    state.coaches = state.coaches.filter(coach => coach.id !== id);

    return true;
  } catch (error) {
    console.error('Error in deleteCoach:', error);
    return false;
  }
};
